/* eslint-disable max-len */
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModalComponent from '@avtechsoftware/react-component-library/src/components/common/modals/ModalComponent';
import FormErrorHandler from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import FormAlertBox from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormAlertBox/FormAlertBox';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import AltErrorWrapper from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';
import {
  checkIfObjectHasEmptyValues, textInputValidationRules, validateObjectValues,
} from '@avtechsoftware/ra-javascript-utilities/src/utilities/validation/ObjectListUtils';
import { connectModalContainerContextToComponent } from '../../../contexts/ModalContext/ModalContext';

function EditReferralAddressModal({
  setModalJSX,
  address,
  submitAddress,
  countries,
  addressMissing,
  clearAddress,
}) {
  const addressToEdit = { ...address };
  const [selectedAddress, setSelectedAddress] = useState(addressToEdit);
  const [isConsented, setIsConsented] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState([]);

  const handleCloseModal = () => setModalJSX(<></>);

  const handleOnChangeCountry = (e) => {
    const { value } = e.target;
    setSelectedAddress({
      ...selectedAddress,
      country: value,
    });
  };

  const handleSubmitAddress = () => {
    if (checkIfObjectHasEmptyValues(selectedAddress)) {
      const textInputs = {
        name: selectedAddress.name,
        streetLine1: selectedAddress.streetLine1,
        locality: selectedAddress.locality,
        state: selectedAddress.state,
        postalCode: selectedAddress.postalCode,
      };

      const errorList = validateObjectValues(
        textInputs, textInputValidationRules,
      );
      if (errorList.length > 0) {
        setFormErrors(errorList);
      } else {
        setIsSubmitting(true);
        submitAddress(selectedAddress);
      }
      setIsSubmitting(false);
    } else {
      setIsSubmitting(true);
      submitAddress(selectedAddress);
    }
  };
  /* istanbul ignore next */
  return (
    <ModalComponent
      size="lg"
      show
      close={handleCloseModal}
      showConfirmCallToAction
      isBtnDisabled={!isConsented || isSubmitting}
      confirmButtonAction={handleSubmitAddress}
      confirmButtonText={isSubmitting ? 'Saving...' : 'Save Changes'}
    >
      <Modal.Header
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        closeButton
      >
        <Modal.Title className="ml-auto">
          Reward checks will be delivered to you at:
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormErrorHandler
          errorList={formErrors}
          fieldList={[
            'name',
            'streetLine1',
            'streetLine2',
            'locality',
            'state',
            'postalCode',
            'country',
          ]}
        >
          <FormAlertBox hasFieldErrors={formErrors.length > 0} genericErrorList={formErrors} />
          <form>
            <div className="container px-5">
              {!addressMissing && (
                <div className="clearfix">
                  <div className="float-right">
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={clearAddress}
                    >
                      Remove my address
                      {' '}
                      <Icon icon="trash" />
                    </button>
                  </div>
                </div>
              )}
              <AltErrorWrapper fieldId="name">
                <input
                  type="text"
                  placeholder="Name"
                  id="name"
                  name="name"
                  value={selectedAddress.name}
                  onChange={(e) => setSelectedAddress({
                    ...selectedAddress,
                    name: e.target.value,
                  })}
                  className="form-control always-inline my-2"
                />
              </AltErrorWrapper>
              <AltErrorWrapper fieldId="streetLine1">
                <input
                  type="text"
                  placeholder="Street Address - Line 1"
                  id="streetLine1"
                  name="streetLine1"
                  value={selectedAddress.streetLine1}
                  onChange={(e) => setSelectedAddress({
                    ...selectedAddress,
                    streetLine1: e.target.value,
                  })}
                  className="form-control always-inline my-2"
                />
              </AltErrorWrapper>
              <input
                value={selectedAddress.streetLine2}
                placeholder="Street Address - Line 2"
                id="streetLine2"
                name="streetLine2"
                onChange={(e) => setSelectedAddress({
                  ...selectedAddress,
                  streetLine2: e.target.value,
                })}
                className="form-control always-inline my-2"
              />
              <AltErrorWrapper fieldId="locality">
                <input
                  type="text"
                  placeholder="City"
                  id="city"
                  name="city"
                  value={selectedAddress.locality}
                  onChange={(e) => {
                    setSelectedAddress({
                      ...selectedAddress,
                      locality: e.target.value,
                    });
                  }}
                  className="form-control always-inline my-2"
                />
              </AltErrorWrapper>
              <AltErrorWrapper fieldId="state">
                <input
                  type="text"
                  placeholder="State/Province"
                  id="state"
                  name="state"
                  value={selectedAddress.state}
                  onChange={(e) => {
                    setSelectedAddress({
                      ...selectedAddress,
                      state: e.target.value,
                    });
                  }}
                  className="form-control always-inline my-2"
                />
              </AltErrorWrapper>
              <AltErrorWrapper fieldId="postalCode">
                <input
                  type="text"
                  placeholder="Postal Code"
                  id="postalCode"
                  name="postalCode"
                  value={selectedAddress.postalCode}
                  onChange={(e) => {
                    setSelectedAddress({
                      ...selectedAddress,
                      postalCode: e.target.value,
                    });
                  }}
                  className="form-control always-inline my-2"
                />
              </AltErrorWrapper>
              <select
                name="country"
                className="form-control always-inline my-2"
                value={selectedAddress.country}
                onChange={handleOnChangeCountry}
              >
                <option value="">- Choose a Country -</option>
                {countries.filter((c) => c.crmId !== 0).map((country, index) => (
                  <option
                    key={`${country.crmId}-${index}`}
                    value={country.name}
                  >
                    {country.name}
                  </option>
                ))}
              </select>
              <div className="form-group always-inline my-2">
                <div className="form-check">
                  <label className="form-check-label" htmlFor="gridCheck1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="consentCheckbox"
                      name="consentCheckbox"
                      value={isConsented}
                      onChange={() => setIsConsented(!isConsented)}
                    />
                    I consent to the provided information being used by AVTECH to manage my personal account.
                  </label>
                </div>
              </div>
            </div>
          </form>
        </FormErrorHandler>
      </Modal.Body>
    </ModalComponent>
  );
}

EditReferralAddressModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  address: PropTypes.shape({
    name: PropTypes.string,
    streetLine1: PropTypes.string,
    streetLine2: PropTypes.string,
    locality: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
  }).isRequired,
  submitAddress: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    crmId: PropTypes.number,
    code: PropTypes.number,
    name: PropTypes.string,
    abbreviation: PropTypes.string,
  })).isRequired,
  addressMissing: PropTypes.bool.isRequired,
  clearAddress: PropTypes.func.isRequired,
};

export { EditReferralAddressModal };
export default connectModalContainerContextToComponent(EditReferralAddressModal);
